import {
  useMutation,
  useQueryClient,
} from 'react-query'

import httpClient from './httpClient'

const Put = ( endpoint, params ) => {
  const queryClient = useQueryClient()

  const putQueryFunction = ( { id, ...rest } ) => new Promise( ( resolve, reject ) => {
    httpClient.put( `${ endpoint + id }/`, { ...rest } )
      .then( ( { data } ) => {
        resolve( data )
      } )
      .catch( ( e ) => {
        reject( e )
      } )
  } )

  return useMutation( putQueryFunction, {
    // Refetch data after mutation
    onSettled: () => {
      queryClient.invalidateQueries( endpoint )
    },
  } )
}

export default Put